import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "", as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </M>
  );
};

export const Overline = ({ children, index }) => (
  <div className="flex items-center gap-3 mb-4">
    {index && <span className="font-serif text-gold text-lg">{index}</span>}
    <span className="text-xs uppercase tracking-[0.3em] text-gold">{children}</span>
  </div>
);
